import { render, staticRenderFns } from "./ProductCustomers.vue?vue&type=template&id=63078fff&"
import script from "./ProductCustomers.vue?vue&type=script&lang=ts&"
export * from "./ProductCustomers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports